'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck } from '@subframe/core';
import { Badge, Button } from '@/shared/components/ui';
import type { PlanoView } from '../types';
interface PlanoCardProps {
  plano: PlanoView;
  ctaLabel: string;
  ctaVariant?: 'brand-primary' | 'neutral-secondary';
  onCta: () => void;
  selecionado?: boolean;
}
const ListaRecursos = t0 => {
  const $ = _c(7);
  const {
    titulo,
    itens
  } = t0;
  let t1;
  if ($[0] !== titulo) {
    t1 = <span className="text-[11px] font-bold tracking-wider text-neutral-500 uppercase">{titulo}</span>;
    $[0] = titulo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== itens) {
    t2 = itens.map(_temp);
    $[2] = itens;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex flex-col gap-2">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export const PlanoCard = t0 => {
  const $ = _c(39);
  const {
    plano,
    ctaLabel,
    ctaVariant: t1,
    onCta,
    selecionado: t2
  } = t0;
  const ctaVariant = t1 === undefined ? "neutral-secondary" : t1;
  const selecionado = t2 === undefined ? false : t2;
  const destacado = plano.destaque || selecionado;
  const t3 = `flex w-full max-w-[320px] flex-1 basis-[260px] flex-col gap-5 rounded-[16px] border-2 border-solid p-6 transition-all ${destacado ? "border-brand-600 bg-brand-50 shadow-md" : "border-neutral-200 bg-white"}`;
  let t4;
  if ($[0] !== plano.nome) {
    t4 = <span className="text-heading-dark text-lg font-bold">{plano.nome}</span>;
    $[0] = plano.nome;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== plano.badge) {
    t5 = plano.badge && <Badge variant="brand">{plano.badge}</Badge>;
    $[2] = plano.badge;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <div className="flex items-center justify-between">{t4}{t5}</div>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== plano.preco) {
    t7 = <span className="text-heading-dark text-[30px] leading-none font-bold">{plano.preco}</span>;
    $[7] = plano.preco;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== plano.precoSufixo) {
    t8 = <span className="text-label-muted pb-1 text-[15px] font-medium">{plano.precoSufixo}</span>;
    $[9] = plano.precoSufixo;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7 || $[12] !== t8) {
    t9 = <div className="flex items-end gap-1">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== plano.franquia) {
    t10 = <span className="text-heading-dark text-[13px] font-semibold">{plano.franquia}</span>;
    $[14] = plano.franquia;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== plano.porEnvio) {
    t11 = <span className="text-[13px] text-neutral-500">{plano.porEnvio}</span>;
    $[16] = plano.porEnvio;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t10 || $[19] !== t11 || $[20] !== t9) {
    t12 = <div className="flex flex-col gap-0.5">{t9}{t10}{t11}</div>;
    $[18] = t10;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== ctaLabel || $[23] !== ctaVariant || $[24] !== onCta) {
    t13 = <Button size="small" className="w-full" variant={ctaVariant} onClick={onCta}>{ctaLabel}</Button>;
    $[22] = ctaLabel;
    $[23] = ctaVariant;
    $[24] = onCta;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== plano.canais) {
    t14 = <ListaRecursos titulo="Canais" itens={plano.canais} />;
    $[26] = plano.canais;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== plano.plataforma) {
    t15 = <ListaRecursos titulo="Plataforma" itens={plano.plataforma} />;
    $[28] = plano.plataforma;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t14 || $[31] !== t15) {
    t16 = <div className="flex flex-col gap-4 border-t border-solid border-neutral-200 pt-4">{t14}{t15}</div>;
    $[30] = t14;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t16 || $[36] !== t3 || $[37] !== t6) {
    t17 = <div className={t3}>{t6}{t12}{t13}{t16}</div>;
    $[33] = t12;
    $[34] = t13;
    $[35] = t16;
    $[36] = t3;
    $[37] = t6;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
function _temp(item) {
  return <div key={item} className="flex items-start gap-2 text-[13px] text-neutral-700"><FeatherCheck className="text-success-700 mt-0.5 h-3.5 w-3.5 flex-none" /><span>{item}</span></div>;
}